import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";

function Topbar() {
  const { instance, accounts } = useMsal();
  const [showMenu, setShowMenu] = useState(false);
  const user = accounts[0] || {};
  const initials = user.name ? user.name.split(" ").map(n => n[0]).join("").substring(0,2).toUpperCase() : "?";

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
  };

  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0 28px", height:"56px", background:"#18073a", position:"sticky", top:0, zIndex:50 }}>
      <div style={{ display:"flex", alignItems:"center", gap:"16px" }}>
        <span style={{ fontSize:"18px", fontWeight:700, color:"#fff", letterSpacing:"0.08em" }}>INSPIRED</span>
        <div style={{ width:"0.5px", height:"18px", background:"rgba(255,255,255,0.2)" }}></div>
        <span style={{ fontSize:"11px", color:"rgba(255,255,255,0.45)", fontWeight:400, letterSpacing:"0.04em", textTransform:"uppercase" }}>Contractor Management</span>
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:"10px", position:"relative" }}>
        <div style={{ textAlign:"right" }}>
          <div style={{ fontSize:"12px", fontWeight:600, color:"#fff" }}>{user.name || "Loading..."}</div>
          <div style={{ fontSize:"11px", color:"rgba(255,255,255,0.5)", fontWeight:300 }}>{user.username || ""}</div>
        </div>
        <div
          onClick={() => setShowMenu(!showMenu)}
          style={{ width:"32px", height:"32px", borderRadius:"50%", background:"#cc8943", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px", fontWeight:700, color:"#fff", cursor:"pointer" }}
        >
          {initials}
        </div>
        {showMenu && (
          <div style={{ position:"absolute", top:"44px", right:0, background:"#fff", borderRadius:"8px", boxShadow:"0 8px 24px rgba(24,7,58,0.15)", minWidth:"140px", overflow:"hidden", zIndex:100 }}>
            <div
              onClick={handleLogout}
              style={{ padding:"12px 16px", fontSize:"12px", fontWeight:500, color:"#82162d", cursor:"pointer" }}
              onMouseEnter={e => e.currentTarget.style.background="#f5e8ea"}
              onMouseLeave={e => e.currentTarget.style.background="#fff"}
            >
              Sign out
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Topbar;